import StatusLabel from "../../StatusLabel";
function SearchUserOption({item}) {
	return (
		<div className="d-flex gap-1">
			{`${item.firstname} ${item.lastname}`}
			<StatusLabel small type={item.role?.badge}>{item.role?.label}</StatusLabel>
		</div>
	)
}

export default SearchUserOption;